export const AlbertaSupportsContactCentreTollFree = '1-877-644-9992';
export const AlbertaSupportsContactCentreEmail = 'scss.ascc@gov.ab.ca';
export const HelpInfoTitle = `Getting more help`;
export const HelpInfoDescription = `If you have any questions, or want clarification, please contact:`;
export const HelpInfoPhoneDefault = '1-877-644-9992';
export const HelpInfoEdmonton = '780-644-9992';
export const AlbertaSupportsContactCentre = 'Alberta Supports Contact Centre';
export const HelpInfoOfficeHours = '7:30 a.m. - 8:00 p.m., Monday to Friday, closed statutory holidays';
export const PremadeContactBoxContent = `<strong>${AlbertaSupportsContactCentre}</strong><br />
    Toll-free: <a href="tel:${HelpInfoPhoneDefault}">${HelpInfoPhoneDefault}</a
    ><br />
    Toll-free (Edmonton): <a href="tel:${HelpInfoEdmonton}">${HelpInfoEdmonton}</a> <br /><br />
    <strong>Office hours:</strong><br />
    ${HelpInfoOfficeHours}`;